<template>
  <div class="tw:h-[200px] tw:flex tw:items-center tw:justify-center">
    <div class="tw:flex tw:flex-col tw:items-center">
      <NoData class="tw:size-16" />
      <p class="tw:text-center">{{ $t('tbs_performance_no_data') }}</p>
    </div>
  </div>
</template>
<script setup>
import NoData from '@/components/icons/NoData.svg?component'
</script>
